<template>
  <div class="dishes-container">
    <van-nav-bar left-arrow left-text="HOME" @click-left="$router.go(-1)" right-text="ISTRUZIONE" title="MENU" @click-right="showIstruction" />
    <dishes></dishes>
    <div v-show="!$store.state.showCart"><tab-bar></tab-bar></div>
    <van-popup v-if="$store.state.showCart" v-model="$store.state.showCart" position="right" :style="{ height: '100%', width:'420px', maxWidth:'100%' }">
      <shopping-cart></shopping-cart>
    </van-popup>

    <van-popup  :round="true" :style="{ height: '768px', width:'476px', maxWidth:'100%', overflow:'hidden', zIndex:9999999}" v-model="showIstructionPopup">
          <div style="position:relative; height:100%; overflow-y:scroll;">
            <div style="padding-bottom:80px; padding-top:20px; line-height:24px;">
              <div style="padding:0 10px;" v-html="istruction"></div>
            </div>
            <van-button style="width:100%; height:60px; position:fixed; bottom: 0px; font-size:30px;" @click="closeIstruction" type="primary">Menu</van-button>
          </div>
    </van-popup>
  </div>
</template>

<script>
  import Dishes from '@/components/Dishes'
  import TabBar from '@/components/TabBar'
  import ShoppingCart from '@/components/Cart.vue'

  export default {
    name: 'Home',
    components: {
      Dishes,
      TabBar,
      ShoppingCart
    },
    data(){
      return {
        showCart: false,
        showIstructionPopup:false,
        istruction:''
      }
    },
    methods:{
      closeCartDialog(){
        this.showCart = false
      },
      showIstruction(){
        this.axios.get('/api/shopInfo/menuPage?mid='+this.$route.params.mid).then((res) =>{
            this.istruction = res.data.data.launch_istruction     
        })
        this.showIstructionPopup = true
      },

      closeIstruction(){
        const now = new Date()
        const time = now.getTime() + (60 * 60 * 24)
        localStorage.setItem('istruction_launch', time)
        this.showIstructionPopup = false
      },
    }
  }
</script>
<style>
  .main-container{
    height: 100%;
  }
  .dishes-container{
    height: calc(100% - (1px - 1px));
    overflow: hidden;
  }
</style>
